import { cva } from 'class-variance-authority';

/**
 * Styles for ResetPasswordFields component
 * Uses responsive spacing
 */
export const resetPasswordFieldsStyles = cva(
  [
    'space-y-4', // Mobile: 16px gap
    'md:space-y-6', // Tablet/Desktop: 24px gap
  ],
  {
    variants: {},
    defaultVariants: {},
  }
);
